import { useMenuStepContext } from 'context/MenuStepContext';

/**
 * Menu step state shared across the app (Header, MainLayout, edit pages).
 * Must be used within Layout (MenuStepProvider).
 */
export const useMenuStep = () => useMenuStepContext();
